import React from 'react';
import { Link } from 'react-router-dom';

const SuccessAlert = ({ title, text, link }) => {
 return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-red-100 shadow-lg rounded-lg p-[90px]">
        <div className="flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 bg-green-600 text-white rounded-full md:w-12 md:h-12 lg:w-14 lg:h-14" viewBox="0 0 512 512">
            <path d="M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z" fill="currentColor" />
            <path d="M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z" fill="currentColor" />
          </svg>
        </div>
        <div className="text-center mt-4">
          <h3 className="text-2xl font-semibold text-gray-900 md:text-3xl lg:text-4xl">{title}</h3>
          <p className="text-gray-600 mt-2 text-center overflow-hidden overflow-ellipsis whitespace-nowrap">{text}</p>
          <p className="text-gray-600 mt-2">Have a great day!</p>
        </div>
        <div className="mt-6 items-center text-center">
          <Link to={link} className="inline-block px-4 py-2 text-white font-semibold bg-indigo-600 rounded hover:bg-indigo-500 md:px-6 md:py-3 lg:px-8 lg:py-4">
            Go Back
          </Link>
        </div>
      </div>
    </div>
 );
};

export default SuccessAlert;
